<div class="description">{{ 'CAN_CHOOSE_ONE_OPTION' | translate }}</div>
<mat-radio-group
        class="radio-group"
        *ngIf="options.length"
        (change)="onChange($event.value)"
        [value]="defaultValue">
    <mat-radio-button
            class="radio-button"
            [value]="option.value"
            *ngFor="let option of options">
        <img alt="" class="radio-icon" src="./assets/img/radio-icon-done.svg">
        <span class="radio-text">{{option.name}}</span>
        <span class="radio-price"
              *ngIf="option.price !== null">{{option.price | currency:('CURRENCY_SYMBOL' | translate):('CURRENCY_SIGN' | translate)}}</span>
    </mat-radio-button>
</mat-radio-group>
